import { Localization } from '../enums/localization.enum';

const IP_LOCATOR_URL = 'https://d1gg5v52bwd33q.cloudfront.net';

export const lookupAddress = () => {
  return fetch(IP_LOCATOR_URL)
    .then((response) => response.json())
    .then((json) => {
      const countryCode = json.country.toLowerCase() !== Localization.Uzbekistan ? 'en' : Localization.Uzbekistan;

      return { countryCode };
    })
    .catch(() => ({ countryCode: 'en' }));
};
